//cspell:disable
export const mapEvents = [
  'error',
  'load',
  'idle',
  'remove',
  'render',
  'resize',
  'webglcontextlost',
  'webglcontextrestored',
  'dataloading',
  'data',
  'tiledataloading',
  'sourcedataloading',
  'styledataloading',
  'sourcedata',
  'styledata',
  'boxzoomcancel',
  'boxzoomstart',
  'boxzoomend',
  'touchcancel',
  'touchmove',
  'touchend',
  'touchstart',
  'click',
  'contextmenu',
  'dblclick',
  'mousemove',
  'mouseup',
  'mousedown',
  'mouseout',
  'mouseover',
  'movestart',
  'move',
  'moveend',
  'zoomstart',
  'zoom',
  'zoomend',
  'rotatestart',
  'rotate',
  'rotateend',
  'dragstart',
  'drag',
  'dragend',
  'pitchstart',
  'pitch',
  'pitchend',
  'wheel',
]
